import { TopupandPaymentDetails } from 'modules/topup-and-payments/components/topup-and-payment-details';
import { useParams } from 'react-router-dom';

export function TopupandPaymentDetailsPage() {
  const { transactionId } = useParams<{ transactionId: string }>();

  return <TopupandPaymentDetails transactionId={transactionId} />;
}
